module.exports = __webpack_public_path__ + "img/bg3.e73f0198.jpg";